export default "__VITE_PUBLIC_ASSET__fd032b2a__"